<template>
  <el-dialog
    title="消息提示"
    :visible.sync="areaFormVisible"
    width="500px"
    :before-close="cancelHandle"
    class="area-dialog"
    :append-to-body="true"
  >
    <el-form :model="areaForm" :rules="areaRules" ref="areaForm">
      <el-form-item label label-width="100px" class="message-box">
        <p class="message">
          您正在操作拒绝对账单，此对账单将变为已拒绝状态，并无法恢复，请填写拒绝原因。
        </p>
      </el-form-item>
      <el-form-item label="拒绝原因：" label-width="100px" prop="refuseReason">
        <el-input
          v-model="areaForm.refuseReason"
          type="textarea"
          :rows="2"
          placeholder="请输入拒绝原因"
          maxlength="300"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="areaHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    areaFormVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      test: "",
      areaForm: { refuseReason: "" },
      areaRules: {
        refuseReason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }],
      },
    };
  },
  methods: {
    cancelHandle() {
      this.$refs.areaForm.resetFields();
      this.$emit("update:areaFormVisible", false);
    },
    // 区域改变
    areaChange() {},
    // 确定按钮
    areaHandle() {
      this.$refs.areaForm.validate(valid => {
        if (valid) {
          this.$emit("refuseHandle", this.areaForm.refuseReason, 2);
          this.cancelHandle();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.area-dialog {
  ::v-deep .el-select {
    width: 100%;
  }
  .message-box {
    margin-bottom: 20px;
    ::v-deep .el-form-item__content {
      line-height: 1;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
